export function copyToClipboard(textToCopy) {
  if (!navigator.clipboard) {
    // Clipboard API not available
    return;
  }
  try {
    navigator.clipboard.writeText(textToCopy);
  } catch (err) {
    // oxlint-disable-next-line no-console
    console.error('Failed to copy!', err);
  }
}
